import Vue from 'vue'

export async function getUIConfig(body: any) {
  const { data } = await Vue.prototype.$http.post(
    '/liveness/h5/v1/getUIConfig',
    body)

  return data
}
